export default __webpack_public_path__ + "static/media/480_portfolio03-it-web.0fd2c55f.png";